// extracted by mini-css-extract-plugin
module.exports =  {"standard":"da51a739f7--standard--khu6p","item":"da51a739f7--item--lKLEq","fsk":"da51a739f7--fsk--l5lRb"};